import React, { useState } from "react";
import { X } from "lucide-react";
import Button from "../../utils/Button";
import UploadsGeneric from "../../utils/UploadsGeneric";
import apiCall from "../../network/api";
import { ONBOARDING_STATUS } from "../../utils/constants";
const OnboardingStep4 = (props) => {
  const {
    verificationLoader,
    handleRowUpdate,
    rowData,
    setVerificationLoader,
  } = props;

  const [selectedCV, setSelectedCV] = useState([]);
  const [selectedPassportFront, setSelectedPassportFront] = useState([]);
  const [selectedPassportBack, setSelectedPassportBack] = useState([]);

  const [CVerror, setCVerror] = useState(false);
  const [passportFrError, setPassportFrError] = useState(false);
  const [passportBackError, setPassportBackError] = useState(false);

  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const headerStyle = {
    fontSize: "20px",
    fontWeight: "600",
    color: "#3C3C3C",
    margin: "2rem 0rem 1rem 0rem",
  };

  const currentDate = new Date();

  // Format the date as "Nov 15, 2024"
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const handleCVChange = (e) => {
    setCVerror(false);
    const file = e.target.files;

    let newImages = [];
    Array.from(file).forEach((file) => {
      if (file.size > 5 * 1024 * 1024) {
        setCVerror("All selected files must be 5 MB or smaller.");
      } else {
        let upload = {
          name: encodeURIComponent(file?.name),
          size: file?.size,
          type: file?.type,
          lastModified: file?.lastModified,
          lastModifiedDate: file?.lastModifiedDate,
          webkitRelativePath: file?.webkitRelativePath,
          file: file,
        };
        newImages.push(upload);
      }
    });
    e.target.value = null;
    if (newImages?.length > 0) {
      setSelectedCV([...newImages]);
    }
  };

  const removeCV = () => {
    setSelectedCV([]);
  };

  const handlePassportFrontChange = (e) => {
    setPassportFrError(false);
    const file = e.target.files;

    let newImages = [];
    Array.from(file).forEach((file) => {
      if (file.size > 5 * 1024 * 1024) {
        setPassportFrError("All selected files must be 5 MB or smaller.");
      } else {
        let upload = {
          image: URL.createObjectURL(file),
          name: encodeURIComponent(file?.name),
          size: file?.size,
          type: file?.type,
          lastModified: file?.lastModified,
          lastModifiedDate: file?.lastModifiedDate,
          webkitRelativePath: file?.webkitRelativePath,
          file: file,
        };
        newImages.push(upload);
      }
    });
    e.target.value = null;
    if (newImages?.length > 0) {
      setSelectedPassportFront([...newImages]);
    }
  };

  const removePassportFront = () => {
    setSelectedPassportFront([]);
  };

  const handlePassportBackChange = (e) => {
    setPassportBackError(false);
    const file = e.target.files;

    let newImages = [];
    Array.from(file).forEach((file) => {
      if (file.size > 5 * 1024 * 1024) {
        setPassportBackError("All selected files must be 5 MB or smaller.");
      } else {
        let upload = {
          image: URL.createObjectURL(file),
          name: encodeURIComponent(file?.name),
          size: file?.size,
          type: file?.type,
          lastModified: file?.lastModified,
          lastModifiedDate: file?.lastModifiedDate,
          webkitRelativePath: file?.webkitRelativePath,
          file: file,
        };
        newImages.push(upload);
      }
    });
    e.target.value = null;
    if (newImages?.length > 0) {
      setSelectedPassportBack([...newImages]);
    }
  };

  const removePassportBack = () => {
    setSelectedPassportBack([]);
  };

  const getPresignedUrl = async (
    folderName,
    subFolderName,
    fileName,
    fileType
  ) => {
    try {
      const result = apiCall({
        endpoint: "/generate-presigned-url",
        method: "POST",
        data: JSON.stringify({ folderName, subFolderName, fileName, fileType }),
      }).then((data) => {
        return data?.url;
      });
      return result;
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = () => {
    const uploadFile = async (file, type) => {
      const url = await getPresignedUrl(
        "obcOnboarding",
        rowData?.email + type,
        encodeURIComponent(file.name),
        file.type
      );
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
        },
        body: file,
      });

      if (response.ok) {
        const fileUrl = download(type).then((data) => {
          return data;
        });

        return fileUrl;
      } else {
      }
    };
    setVerificationLoader(true);
    uploadFile(selectedPassportFront?.[0]?.file, "passportFront");
    uploadFile(selectedPassportBack?.[0]?.file, "passportBack");
    uploadFile(selectedCV?.[0]?.file, "cv");
    handleRowUpdate({
      updateData: {
        onboardingStatus: {
          status: ONBOARDING_STATUS.IN_REVIEW,
        },
        onboardingStatusTime: formattedDate,
      },
    });
  };

  const download = async (type) => {
    let passportFront = {};
    let passportBack = {};
    let cv = {};
    const urls = await getDownloadUrls(
      `obcOnboarding/${rowData?.email}${type}`
    ).then((data) => {
      if (type === "cv") {
        cv = {
          url: data?.[0]?.url,
          name: data?.[0]?.name,
          attachmentType: "LINK",
          description: type,
        };
        const res = apiCall({
          endpoint: "/otp/attach-to-smartsheet",
          method: "POST",
          data: {
            rowId: rowData?.email,
            email: rowData?.email,
            attachment: cv,
          },
        }).then((data) => {
          return data;
        });
        return res;
      }
      if (type === "passportFront") {
        passportFront = {
          url: data?.[0]?.url,
          name: data?.[0]?.name,
          attachmentType: "LINK",
          description: type,
        };
        const res = apiCall({
          endpoint: "/otp/attach-to-smartsheet",
          method: "POST",
          data: {
            rowId: rowData?.email,
            email: rowData?.email,
            attachment: passportFront,
          },
        }).then((data) => {
          return data;
        });
        return res;
      }
      if (type === "passportBack") {
        passportBack = {
          url: data?.[0]?.url,
          name: data?.[0]?.name,
          attachmentType: "LINK",
          description: type,
        };
        const res = apiCall({
          endpoint: "/otp/attach-to-smartsheet",
          method: "POST",
          data: {
            rowId: rowData?.email,
            email: rowData?.email,
            attachment: passportBack,
          },
        }).then((data) => {
          return data;
        });
        return res;
      }
      return true;
    });

    return urls;
  };

  const getDownloadUrls = async (folderName) => {
    try {
      const result = await apiCall({
        endpoint: "/generate-download-urls",
        method: "POST",
        data: JSON.stringify({ folderName }),
      }).then((data) => {
        return data;
      });
      return result;
    } catch (err) {}
  };

  return (
    <div style={{ width: "100%", color: "#3C3C3C" }}>
      <div style={headerStyle} className="flex flex-col gap-3">
        <p className="text-gray-500 text-md font-bold">Documents</p>
        <UploadsGeneric
          error={CVerror}
          fileType={"pdf"}
          handleFileChange={handleCVChange}
          removeFile={removeCV}
          title={"Latest updated CV"}
          header={"Please upload latest CV here"}
          selectedFile={selectedCV}
          id={"uploadCV-input"}
        />
        <UploadsGeneric
          error={passportFrError}
          fileType={"image"}
          handleFileChange={handlePassportFrontChange}
          removeFile={removePassportFront}
          title={"Passport Front side"}
          header={"Please upload front side here"}
          id={"uploadPassportFr-input"}
          selectedFile={selectedPassportFront}
        />
        <UploadsGeneric
          error={passportBackError}
          fileType={"image"}
          handleFileChange={handlePassportBackChange}
          removeFile={removePassportBack}
          title={"Passport Back side"}
          header={"Please upload back side here"}
          id={"uploadPassportBack-input"}
          selectedFile={selectedPassportBack}
        />
      </div>

      <br />
      <label className="flex items-start gap-2 text-xs text-gray-700 mb-3 cursor-pointer">
        <input
          type="checkbox"
          checked={acceptedTerms}
          onChange={(e) => setAcceptedTerms(e.target.checked)}
          className="mt-0.5"
        />
        <span>
          I accept the{" "}
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setShowTerms(true);
            }}
            className="underline text-blue-600"
          >
            Terms of use and Privacy Policy
          </button>
        </span>
      </label>

      {showTerms && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4 z-50"
          onClick={() => setShowTerms(false)}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-full max-w-3xl h-[85vh] flex flex-col overflow-hidden"
            onClick={(e) => e.stopPropagation()}
            onContextMenu={(e) => e.preventDefault()}
          >
            <div className="flex justify-between items-center px-4 py-3 border-b">
              <h2 className="text-md text-gray-600 font-bold">
                Terms of use and Privacy Policy
              </h2>
              <button
                type="button"
                onClick={() => setShowTerms(false)}
                aria-label="Close"
              >
                <X className="h-5 w-5 text-gray-500" />
              </button>
            </div>
            <iframe
              title="Terms of use and Privacy Policy"
              src="/terms_of_use.pdf#toolbar=0&navpanes=0&scrollbar=0"
              className="flex-1 w-full"
            />
          </div>
        </div>
      )}
      <Button
        text={"Submit"}
        size={"md"}
        onClick={() => handleSubmit()}
        loading={verificationLoader}
        disabled={
          !(
            acceptedTerms &&
            selectedCV?.length > 0 &&
            selectedPassportBack?.length > 0 &&
            selectedPassportFront?.length > 0
          )
        }
      />
    </div>
  );
};

export default OnboardingStep4;
